import { Content } from "antd/es/layout/layout";
import React, { Suspense } from "react";
import Headers from "./Header";
import { Layout } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Loading from "./Loading";

const AuthLayout = () => {
  const { pathname } = useLocation();
  
  // Add routes where header should be hidden
  const hideHeaderRoutes = ['/questions-details'];
  const shouldShowHeader = !pathname.includes(hideHeaderRoutes);

  return (
    <Layout className="min-h-screen flex flex-col w-full bg-primaryOpacity">
      {shouldShowHeader && <Headers />}
      <Content className={`flex-grow flex ${shouldShowHeader ? 'pt-[8vh]' : ''} w-full`}>
        <div className="flex-1 flex w-full max-w-full overflow-x-hidden">
          <Suspense
            fallback={<Loading></Loading>}
          >
            <Outlet />
          </Suspense>
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default AuthLayout;